// dependent jquery
import { BaseTag }   from "mixs/base/base_mixin";
import { api }       from "apps/api";
import RiotEventManager   from 'utilities/riot/event_manager';
import TimeLag from 'utilities/timelag';
import { Scopes } from 'apps/scopes';
import ReadController from 'mixs/notifications/read-controller';
export class NotificaionsHeader extends BaseTag {
  eventManager: RiotEventManager;
  intervalId: number;
  showLag: TimeLag;
  init(){
    super.init();
    this.watch();
    this.listenMount([this.onMountNotificationHeader]);
  }
  onMountNotificationHeader(){
    this.setTimer();
    $(this.rootElement).on('show.bs.dropdown', () => { this.onShow(); } );
    $(this.rootElement).on('hide.bs.dropdown', () => { this.onHide(); } );
  }
  setTimer(){
    // setInterval(() => {this.getItems();}, 5000);
    this.intervalId = window.setInterval(() => {this.getItems();}, 180000);
  }
  getItems(){
    if(document.hidden){ return; }
    let payload = {
      url: '/notifications'
    }
    api.get(payload)
      .then((data) => {this.onGetItems(data)})
      .catch((error) => {console.log(error);});
  }
  onGetItems(data){
    this.dispatchNewValue(data.data.notifications_header);
  }
  onShow(){
    this.showLag = new TimeLag(() => { this.onShowLagged() }, 1300);
    this.showLag.start();
  }
  onShowLagged(){
    this.showLag = undefined;
    this.onRead();
  }
  onHide(){
    if(this.showLag == null){ return; }
    this.showLag.clear();
    this.showLag = undefined;
  }
  onRead(){
    let unread_notifications = []
    let items = this.opts.items;
    for(let i=0;i<Math.min(items.length, 4);i++){
      let notificationData = Scopes.getNotificationData(items[i]);
      if(notificationData == null){ continue; }
      if(!notificationData.unread){ continue; }
      if(notificationData.user_id != Scopes.getCurrentUserData().id){ continue; }
      unread_notifications.push(notificationData.id);
    }
    if(unread_notifications.length > 0){
      let c = ReadController.getInstance();
      c.onRead(unread_notifications)
    }
  }
}
riot.mixin('notifications.header', NotificaionsHeader as riot.TagMixin)
